window.VegasCart = {
	addRequest: function (params, callback) {
		$.post('/cart/add_product', params, function (data) {
			if (typeof callback == 'function')
				callback(data);
		});
	},

	changeRequest: function (params, callback) {
		$.post('/cart/change_product', params, function (data) {
			if (typeof callback == 'function')
				callback(data);
		});
	},

	removeRequest: function (params, callback) {
		$.post('/cart/del_product', params, function (data) {
			if (typeof callback == 'function')
				callback(data);
		});
	},

	total: function (data) {
		if (typeof data.products_count !== 'undefined') {
			$('[data-cart=products-count]').text(data.products_count);
		}

		if (typeof data.cart_sum !== 'undefined') {
			$('[data-cart=cart-total]').text(output_money(data.cart_sum));
		}
	},

	updateTotalAll: function () {
		$.get('/cart/get_totals', VegasCart.formData(), function (data) {
			VegasCart.total(data);
		});
	},

	totals: function (data) {
		if (typeof data.products_count !== 'undefined') {
			$('[data-counter=cart-products]').attr('data-cnt', data.products_count);
		}
	},

	getParamsFromProductItem: function ($item) {
		let params = {
			id: $item.data('id'),
			_token: App.csrf,
		};

		let $clickPrice = $item.find('[data-toggle=click-price].current');
		let $selectPrice = $item.find('select[name=price]');
		let $btnToCart = $item.find('[data-cart][data-action="add"]');

		if ($clickPrice.length) {
			params.price = $clickPrice.data('price_name');
		} else if ($selectPrice.length) {
			params.price = $selectPrice.val();
		} else if ($btnToCart.length && $btnToCart.data('price_name')) {
			params.price = $btnToCart.data('price_name');
		}

		let $variant = $item.find('[name=variant]');
		if ($variant.length) {
			params.variant = $variant.val();
		}

		// additionals
		params.additionals = [];

		$item.find('.additional.vg-dropdown').each(function () {
			let $additional = $(this);

			if ($additional.data('countable') && $additional.data('multiple')) {
				$additional.find('.dropdown-item:not(.d-none)').each(function (i, e) {
					let cnt = $(e).find('.cnt').data('cnt');

					if (cnt > 0) {
						params.additionals.push({
							index: $additional.data('index'),
							name: $(e).data('name'),
							cnt: cnt
						});
					}
				});
			} else {
				$additional.find('.dropdown-item.checked:not(.d-none)').each(function (i, e) {
					params.additionals.push({
						index: $additional.data('index'),
						name: $(e).data('name'),
					});
				});
			}
		});
		$item.find('.additional.checkbox input[type=checkbox]:checked').each(function (i, e) {
			let $c = $(this).closest('.checkbox');
			params.additionals.push({
				index: $c.data('index'),
				name: $c.data('name'),
			});
		});

		let $removeIngridients = $item.find('.rmv-ingrd:checked');
		if ($removeIngridients.length) {
			params.remove_ingridients = $removeIngridients.map(function () {
				return $(this).val();
			}).toArray();
		}

		return params;
	},

	totalCartTableProducts: function (totals) {
		for (let i in totals) {
			let p = totals[i];
			let $item = $('[data-product-item-cart][data-pivot_id="' + p.pivot_id + '"]');
			$item.find('.price-area span').text(p.price_formatted);
			$item.find('.total-area span').text(p.price_total_formatted);

			let $containerAppliances = $item.find('.appliances-area .sum');
			if (p.price_appliances > 0) {
				$containerAppliances.text(output_money(p.price_appliances)).show();
			} else {
				$containerAppliances.hide();
			}
		}
	},

	totalCartSums: function (data) {
		if (typeof data.cart_sum != 'undefined') {
			$('[data-counter=cart-total-sum]').html(data.cart_sum_formatted);
		}
		if (typeof data.cart_sum_without_order_site != 'undefined') {
			$('[data-counter=cart-total-sum-without-order-site]').html(data.cart_sum_without_order_site_formatted);
		}
		if (typeof data.cart_sum_discount != 'undefined') {
			$('[data-counter=cart-sum-discount]').html(data.cart_sum_discount_formatted);
		}
	},

	alertSuccess: function () {
		$.toast({
			heading: 'Добавлено в корзину',
			position: 'top-right',
			icon: 'success',
			stack: false
		});
	},
	alertError: function () {
		$.toast({
			heading: 'Не удалось добавить товар в корзину',
			position: 'top-right',
			icon: 'error',
			stack: false
		});
	},
	clearAdditionals: function ($item) {
		$item.find('.additional-counter .cnt').each(function () {
			$(this).data('cnt', 0).text(0);
		});
		$item.find('.dropdown-item.checked').each(function () {
			$(this).removeClass('checked');
		});
		$item.find('.vg-dropdown.additional.no-select').each(function () {
			$(this).removeClass('no-select');
		});
		$item.find('.additional.checkbox input[type=checkbox]:checked').each(function () {
			$(this).prop('checked', false).trigger('change');
		});

		let $price = $item.find('.price');
		let price = ProductItem.calcPrice($item);
		$price.find('span').attr('data-price', price).html(output_money(price));
	}
};

/**
 * Прослушиватели событий корзины
 **/
let $window = $(window),
	$body = $('body'),
	$document = $(document)
;

/** ADD */
$document.on('click', '[data-product-item] [data-cart][data-action=add]', function () {
	let $item = $(this).closest('[data-product-item]');
	let params = VegasCart.getParamsFromProductItem($item);

	VegasCart.addRequest(params, function (data) {
		if (data.error) {
			VegasCart.alertError();
		} else {
			VegasCart.totals(data);
			VegasCart.alertSuccess();
			VegasCart.clearAdditionals($item);

			$item.addClass('in-cart');
		}
	});

	return false;
});
$document.on('click', '[data-product-item-compact] [data-cart][data-action=add]', function () {
	let $item = $(this).closest('[data-product-item-compact]');
	let params = VegasCart.getParamsFromProductItem($item);

	VegasCart.addRequest(params, function (data) {
		if (data.error) {
			VegasCart.alertError();
		} else {
			VegasCart.totals(data);
			VegasCart.alertSuccess();
			VegasCart.clearAdditionals($item);

			$item.addClass('in-cart');
		}
	});

	return false;
});
$document.on('click', '[data-product] [data-cart][data-action=add]', function () {
	let $item = $(this).closest('[data-product]');
	let params = VegasCart.getParamsFromProductItem($item);

	VegasCart.addRequest(params, function (data) {
		VegasCart.totals(data);
		VegasCart.alertSuccess();
		VegasCart.clearAdditionals($item);

		let $modal = $item.closest('#modal-prd');
		$modal.modal('hide');
	});

	return false;
});

/** CHANGE */
$document.on('change-counter', '[data-product-item-cart] .in-counter', function () {
	let $item = $(this).closest('[data-product-item-cart]');

	let params = {
		_token: App.csrf,
		pivot_id: $item.data('pivot_id'),
		cnt: parseInt($(this).val()),
		get_products_totals: true,
		get_discounts_view: true,
		d: (new URLSearchParams(document.location.search)).get('d')
	};

	VegasCart.changeRequest(params, function (data) {
		VegasCart.totalCartTableProducts(data.products_totals);
		VegasCart.totalCartSums(data);

		if (data.discounts_view) {
			let $container = $('.vg-shop-cart--discounts');
			$container.after(data.discounts_view);
			$container.remove();

			$('.vg-shop-cart--discounts').find('[data-modal]').click(function () {
				ModalVegas.init($(this));
				return false;
			});
		}
	});
});

$document.on('change-counter', '[data-product-item-cart] .appliances-counter', function () {
	let $item = $(this).closest('[data-product-item-cart]');

	let params = {
		_token: App.csrf,
		pivot_id: $item.data('pivot_id'),
		appliances: parseInt($(this).val()),
		get_products_totals: true,
		get_discounts_view: true,
	};

	VegasCart.changeRequest(params, function (data) {
		VegasCart.totalCartTableProducts(data.products_totals);
		VegasCart.totalCartSums(data);
	});
});

/** DELETE */
$document.on('click', '[data-product-item-cart] [data-cart][data-action=del]', function () {
	let $item = $(this).closest('[data-product-item-cart]');

	VegasCart.removeRequest({
		_token: App.csrf,
		pivot_id: $item.data('pivot_id'),
	}, function (data) {
		$item.remove();

		VegasCart.totals(data);
		VegasCart.totalCartSums(data);

		let count = $('[data-product-item-cart]').length;
		if (!count) location.reload();
	});

	return false;
});
